//$Id$
//ignorei18n_starts

const _V3 = 'v3' //NO I18N
const _GET = 'GET' //NO I18N
const _PUT = 'PUT' //NO I18N
const _POST = 'POST' //NO I18N
const _DELETE = 'DELETE' //NO I18N
const _PATCH = 'PATCH' //NO I18N
const _JSON = 'json' //NO I18N

class RequestHandler{
    
    static ContentType = {
		FORM: 'application/x-www-form-urlencoded; charset=UTF-8',
		JSON: 'application/json',
		HTML: 'text/html',
	}
	
    static #InstanceRegistry = new Map();

    static async fetch(url, options){
        const key = JSON.stringify({ url, options });
        const instance = this.#InstanceRegistry.has(key);
       /*	if(instance){
            return;
        }*/
        const request = new RequestDispatcher(url, options);
        this.#InstanceRegistry.set(key, request);
        const response = await request.fetch();
        this.#InstanceRegistry.delete(key);
        return response;
    }
    
    static hasPendingReq(){
		return this.#InstanceRegistry.size > 0;
	}

	static removeFromRegistry({url, options}){
		const key = JSON.stringify({ url: this.url, options: this.options });
		this.#InstanceRegistry.delete(key);
	}
    
    static retry(){
		/*this.#InstanceRegistry.forEach((request, key) => {
			request.fetch().then(this.#InstanceRegistry.delete(key));
		});*/
		
		const retryEvent = new CustomEvent('retry');
		window.dispatchEvent(retryEvent);
	}

}

class RequestDispatcher{
	
    static #SERVICE='Projects';
    static #ContentType='contentType';
    static #Accept='accept';
    static #defaultOptions = {
        method: _GET,
        restAPI: true,
        apiVersion: undefined,
    }

    constructor(url, options={}){
		this.url=url;
		this.options = Object.assign({}, RequestDispatcher.#defaultOptions, options);
    }

    async fetch(){
		try{
        	const request = this.#constructRequest(this.url, this.options);
			let response = await fetch(request);
			if(!response.ok){
				if(!window.navigator.onLine){
					throw "Internet Disconnected!!!";
				}else{
					let responseText, error;
					try{
						responseText = await response.text();
						error = JSON.parse(responseText.trim());
					}catch(e){
							throw {data: responseText, responseText, status: response.status};
					}
					throw {data:error, responseText, status: response.status};
				}
			}else{
				let responseText, data;
				try{
					responseText = await response.text();
					responseText = responseText || undefined;
					data = JSON.parse(responseText);
				}catch(error){
					return {data: responseText, responseText, status: response.status};
				}
				return {data, responseText, status: response.status};
			}
			
		}catch(error){
			if(!window.navigator.onLine){
				
				/**
				 * Retry based on user event
				 */
				return new Promise((resolve) => {
					window.addEventListener("retry", async () =>{
						
						location.reload();
						
						/*
						const response = await this.fetch(this.url, this.options);
						RequestHandler.removeFromRegistry({url: this.url, options: this.options});
						return resolve(response);
						*/
					}, {once: true});
				});
				
				/**
				 * Uncomment below lines for auto retry
				 */
				
				/*return new Promise((resolve) => {
					window.addEventListener("online", async () =>{
						const response = await this.fetch(this.url, this.options);
	                	return resolve(response);
	                }, {once: true});
				});*/
			}else if(error instanceof DOMException && error.name == "AbortError"){
				throw {errorThrown: AjaxConstants.PROJECTS_AJAX_ABORT};
			}else{
				throw error;
			}
		}
		
    }

    #constructHeader(headers={}){
		
		const defaultHeaders = {
            'X-ZCSRF-TOKEN': this.#getZPCSRF(),
            'X-ZOHO-SERVICE': RequestDispatcher.#SERVICE,
            'Accept': headers[RequestDispatcher.#Accept] || _JSON,
        };
		if(headers[RequestDispatcher.#ContentType] != false){
			defaultHeaders['Content-Type'] = headers[RequestDispatcher.#ContentType] || RequestHandler.ContentType.FORM
		}
		
		return defaultHeaders;  
    }
    
    #modifyURL(url, options){
		if(options.restAPI && !url.includes("restapi") && !url.includes("api/v3")) {
            url = `${options.apiVersion === _V3 ? '/api/v3' : '/restapi'}/portal/${Utils.zoid}${url}`;
        }
        url = this.#changeRestAPIUrlForCrmPlus(url);
        return url;
	}
    
    #objectToQueryString(obj, parentKey=''){
		let queryString = [];

	    for (let key in obj) {
	        if (obj.hasOwnProperty(key)) {
	            let value = obj[key];
	            let encodedKey = encodeURIComponent(parentKey ? `${parentKey}[${key}]` : key);

				
	            if (Object.prototype.toString.call(value) === '[object Object]') {
	                queryString.push(this.#objectToQueryString(value, encodedKey));
	            }else if(Array.isArray(value)){
					value.forEach(param => {queryString.push(`${encodedKey}=${encodeURIComponent(param)}`);});
				} else {
	                queryString.push(`${encodedKey}=${encodeURIComponent(value)}`);
	            }
	        }
	    }

    return queryString.join('&');
	}
   /*#getFormData(jsonObj){
	    const formData = new FormData();
	 	Object.keys(jsonObj).forEach(key => {
			formData.append(key, jsonObj[key]);
		});
		return formData;
	}*/

    #constructRequest(url, options){
        options.headers = this.#constructHeader(options);
        url = this.#modifyURL(url, options);
        
		options.args = options.args && Object.prototype.toString.call(options.args) === '[object Object]' && options.method != _PATCH ? this.#cleanJsonObj(options.args) : options.args;
		if(options.method == _GET){
			url = options.method == _GET && options.args ? `${url}?${new URLSearchParams(options.args)}`: url;
		}else if(options.processData == false){
			options.body = options.args;
		}else if(options.headers['Content-Type'] == RequestHandler.ContentType.FORM){//no i18n
			options.body = typeof options.args == 'object' ? this.#objectToQueryString(options.args) : options.args;
		}else{//no i18n
			options.body = JSON.stringify(options.args);
		}

		// Manually trigger ajaxSend (used for permission)
		/*Below line should be removed once permission call move to projects route*/
		jQuery && jQuery(document).trigger('ajaxSend', [, {url: url, data: options.body}]);

        return new Request(url, options);
    }
    
    #cleanJsonObj(json){
		return Object.entries(json).filter(([key, value]) => value != undefined  && !isEmptyObject(value)).reduce((obj, [key, value])=> {
			obj[key]=value;
			return obj;
		}, {});
	}

    #getZPCSRFName()
    {
        return "zpcp";
    }

    #getZPCSRFValue()
    {
        return getCookie("zpct");
    }

    #getZPCSRF()
    {
        return `${this.#getZPCSRFName()}=${this.#getZPCSRFValue()}`;
    }

    #changeRestAPIUrlForCrmPlus(url){
        if((typeof IsWPloaded == "undefined" || !IsWPloaded) && (typeof crmpluslibcheck != "undefined" && crmpluslibcheck)){
            return (url.indexOf('/restapi/portal') == 0 || url.indexOf('/api/v3') == 0) ? `/portal${url}` : url;
        }
        return url;
    }
}

class ZPResponse{
	static STATUS = {
		OK: 200,
		NO_CONTENT: 204,
		MULTI_STATUS: 207,
		FORBIDDEN: 403,
		TOO_MANY_REQUESTS: 429
	}
}

Object.assign(window, {RequestHandler, RequestDispatcher, ZPResponse, 
	_V3, _GET, _PUT, _POST, _DELETE, _PATCH, _JSON});
//ignorei18n_ends
